export default function getResource(label) {
    const resources = {
        change: 'Modifier'
    };

    return resources[label];
}
